export default "__VITE_ASSET__DhAv4ylq__"